import { Receipts } from './Receipts';

export default Receipts;
